import { z } from 'zod';

const DEFAULT_INFO_GROUP = 'cz.partners.boa';
const DEFAULT_INFO_NAME = 'backoffice-valhalla';

const buildtimeEnvSchema = z.object({
	CLIENT_VERSION: z.string().optional(),
	CLIENT_INFO_GROUP: z.string().default(DEFAULT_INFO_GROUP),
	CLIENT_INFO_NAME: z.string().default(DEFAULT_INFO_NAME),
});

export const buildtimeEnv = buildtimeEnvSchema.parse(
	// @ts-ignore
	import.meta.env,
);
